export default "__VITE_PUBLIC_ASSET__fb120e7a__"